import React, { useState } from "react"
import "./LibraryGallery.css"

const LibraryGallery = () => {

  const galleryImages = [

 
  

  /* ===== Book Section (6) ===== */
  { id: 13, src: "/campuslife/library/booksection1.JPG", alt: "Book Section – Shelves", category: "Book Section" },
  { id: 14, src: "/campuslife/library/booksection2.JPG", alt: "Book Section – Textbooks", category: "Book Section" },
  { id: 15, src: "/campuslife/library/booksection3.JPG", alt: "Book Section – Journals", category: "Book Section" },
  { id: 16, src: "/campuslife/library/booksection4.JPG", alt: "Book Section – Stack Area", category: "Book Section" },
  { id: 17, src: "/campuslife/library/booksection5.JPG", alt: "Book Section – Periodicals", category: "Book Section" },
  { id: 18, src: "/campuslife/library/booksection6.JPG", alt: "Book Section – General Collection", category: "Book Section" },
/* ===== Study Area (6) ===== */
  { id: 7, src: "/campuslife/library/studyarea1.JPG", alt: "Study Area – Individual", category: "Study Area" },
  { id: 8, src: "/campuslife/library/studyarea2.JPG", alt: "Study Area – Group", category: "Study Area" },
  { id: 9, src: "/campuslife/library/studyarea3.JPG", alt: "Study Area – Quiet Zone", category: "Study Area" },
  { id: 10, src: "/campuslife/library/studyarea4.JPG", alt: "Study Area – Students", category: "Study Area" },
  { id: 11, src: "/campuslife/library/studyarea6.JPG", alt: "Study Area – Workspace", category: "Study Area" },
  { id: 12, src: "/campuslife/library/studyarea5.JPG", alt: "Study Area – Discussion", category: "Study Area" },
  /* ===== Reference Section (6) ===== */
  // { id: 19, src: "/campuslife/library/referencesection1.JPG", alt: "Reference Section – Encyclopedias", category: "Reference Section" },
  { id: 20, src: "/campuslife/library/referencesection2.JPG", alt: "Reference Section – Dictionaries", category: "Reference Section" },
  { id: 21, src: "/campuslife/library/referencesection7.JPG", alt: "Reference Section – Handbooks", category: "Reference Section" },
  { id: 22, src: "/campuslife/library/referencesection4.JPG", alt: "Reference Section – Research Materials", category: "Reference Section" },
  { id: 23, src: "/campuslife/library/referencesection5.JPG", alt: "Reference Section – Academic Resources", category: "Reference Section" },
  { id: 24, src: "/campuslife/library/referencesection6.JPG", alt: "Reference Section – Scholarly Works", category: "Reference Section" },

  /* ===== Digital Library (6) ===== */
  { id: 25, src: "/campuslife/library/digitallibrary1.JPG", alt: "Digital Library – Computer Lab", category: "Digital Library" },
  { id: 26, src: "/campuslife/library/digitallibrary2.JPG", alt: "Digital Library – E-Resources", category: "Digital Library" },
  // { id: 27, src: "/campuslife/library/digitallibrary3.JPG", alt: "Digital Library – Online Journals", category: "Digital Library" },
  // { id: 28, src: "/campuslife/library/digitallibrary4.JPG", alt: "Digital Library – Study Terminals", category: "Digital Library" },
  // { id: 29, src: "/campuslife/library/digitallibrary5.JPG", alt: "Digital Library – Learning Zone", category: "Digital Library" },
  // { id: 30, src: "/campuslife/library/digitallibrary6.JPG", alt: "Digital Library – Workstations", category: "Digital Library" },

  /* ===== Seating Area (6) ===== */
  { id: 31, src: "/campuslife/library/seatingarea3.JPG", alt: "Seating Area – Students", category: "Seating Area" },
  // { id: 32, src: "/campuslife/library/seatingarea2.JPG", alt: "Seating Area – Quiet Zone", category: "Seating Area" },
  { id: 33, src: "/campuslife/library/seatingarea1.JPG", alt: "Seating Area – Reading Tables", category: "Seating Area" },
  { id: 34, src: "/campuslife/library/seatingarea4.JPG", alt: "Seating Area – Comfortable Seating", category: "Seating Area" },
  // { id: 35, src: "/campuslife/library/seatingarea5.JPG", alt: "Seating Area – Study Chairs", category: "Seating Area" },
  // { id: 36, src: "/campuslife/library/seatingarea6.JPG", alt: "Seating Area – Study Tables", category: "Seating Area" },
 /* ===== Reading Hall (6) ===== */
  { id: 1, src: "/campuslife/library/readinghall1.JPG", alt: "Reading Hall – View 1", category: "Reading Hall" },
  { id: 2, src: "/campuslife/library/readinghall2.JPG", alt: "Reading Hall – View 2", category: "Reading Hall" },
  { id: 3, src: "/campuslife/library/readinghall3.JPG", alt: "Reading Hall – View 3", category: "Reading Hall" },
  { id: 4, src: "/campuslife/library/readinghall4.JPG", alt: "Reading Hall – View 4", category: "Reading Hall" },
  // { id: 5, src: "/campuslife/library/readinghall5.JPG", alt: "Reading Hall – View 5", category: "Reading Hall" },
  // { id: 6, src: "/campuslife/library/readinghall6.JPG", alt: "Reading Hall – View 6", category: "Reading Hall" },

  /* ===== Infrastructure (6) ===== */
  { id: 37, src: "/campuslife/library/library_building4.JPG", alt: "Library Building", category: "Infrastructure" },
  { id: 38, src: "/campuslife/library/library_building2.JPG", alt: "Library Entrance", category: "Infrastructure" },
  { id: 39, src: "/campuslife/library/library_building3.JPG", alt: "Library Interior", category: "Infrastructure" },
  { id: 40, src: "/campuslife/library/library_building1.JPG", alt: "Library Corridor", category: "Infrastructure" },
  { id: 41, src: "/campuslife/library/library_building5.JPG", alt: "Library Facilities", category: "Infrastructure" },
//   { id: 42, src: "/campuslife/library/library_building6.JPG", alt: "Library Environment", category: "Infrastructure" }
]


  const categories = ["All", ...new Set(galleryImages.map(img => img.category))]
  const [activeCategory, setActiveCategory] = useState("All")
  const [selectedImage, setSelectedImage] = useState(null)

  const filteredImages =
    activeCategory === "All"
      ? galleryImages
      : galleryImages.filter(img => img.category === activeCategory)

  /* ================================================= */

  return (
    <section id="library-gallery-section">
      <div id="library-gallery-container">

        {/* HEADER */}
        <div id="library-gallery-header">
          <h2 className="library-gallery-title">Library Gallery</h2>
          <p className="library-gallery-subtitle">
            Explore facilities, resources and learning spaces
          </p>
        </div>

        {/* CATEGORY TABS */}
        <div className="library-gallery-tabs">
          {categories.map(cat => (
            <button
              key={cat}
              className={cat === activeCategory ? "active-tab" : ""}
              onClick={() => setActiveCategory(cat)}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* GALLERY GRID */}
        <div id="library-gallery-grid">
          {filteredImages.map(image => (
            <div
              key={image.id}
              className="library-gallery-item fade-in"
              onClick={() => setSelectedImage(image)}
            >
              <img
                src={image.src}
                alt={image.alt}
                loading="lazy"
                className="library-gallery-image"
              />
              <div className="library-gallery-caption">
                {image.alt}
              </div>
            </div>
          ))}
        </div>

      </div>

      {/* LIGHTBOX */}
      {selectedImage && (
        <div className="library-lightbox" onClick={() => setSelectedImage(null)}>
          <div className="library-lightbox-content">
            <img src={selectedImage.src} alt={selectedImage.alt} />
            <p>{selectedImage.alt}</p>
          </div>
        </div>
      )}
    </section>
  )
}

export default LibraryGallery
